import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LanguageWrapper from './components/LanguageWrapper';
import AppRoutes from './AppRoutes';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import './App.css';
import './jquerysetup.js'; // sets up global jQuery first
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';

import { useEffect, useState } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

import './locales/i18n.js';

import ScrollToTop from './components/ScrollToTop.jsx';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import NavbarNew from './components/NavbarNew.jsx';
import BackToTopButton from './components/BackToTopButton.jsx';
import InitialLanguageRedirector from './components/InitialLanguageRedirector.jsx';
import ToasterHost from './components/ToasterHost.jsx';
import LanguageSuggestionBanner from './components/LanguageSuggestionBanner.jsx';

const queryClient = new QueryClient();

function App() {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
    AOS.refresh(); // refresh za sve DOM elemente
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 992);
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const [isMobile, setIsMobile] = useState(false);

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={import.meta.env.VITE_RECAPTCHA_SITE_KEY}
    >
      <Router>
        <InitialLanguageRedirector />
        <ScrollToTop />
        <BackToTopButton />
        <NavbarNew />
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools initialIsOpen={false} />
          <ToasterHost />
          <LanguageSuggestionBanner />
          <div style={{ paddingTop: isMobile ? 70 : 112 }}>
            <Routes>
              {/* English routes */}
              <Route 
                path="/en/*" 
                element={
                  <LanguageWrapper lang="en">
                    <AppRoutes basePath="/en" />
                  </LanguageWrapper>
                } 
              />
              
              {/* Default routes (Bosnian) - no prefix */}
              <Route 
                path="*" 
                element={
                  <LanguageWrapper lang="bs">
                    <AppRoutes basePath="/" />
                  </LanguageWrapper>
                } 
              />
            </Routes>
          </div>
        </QueryClientProvider>
      </Router>
    </GoogleReCaptchaProvider>
  );
}

export default App;
